module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "settings"
    }
  }, [_c('div', [_c('div', [_c('span', [_vm._v("Абонемент")]), _vm._v("\n            " + _vm._s(_vm.account.account.login) + "\n        ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Пакет")]), _vm._v("\n            " + _vm._s(_vm.account.account.packet_name) + "\n        ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Дата окончания")]), _vm._v("\n            " + _vm._s(_vm._f("datetime")(_vm.account.account.packet_expire)) + "\n        ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Сервер вещания")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.account.settings.stream_server.value
    },
    on: {
      "change": function($event) {
        return _vm.sendSettings($event, 'stream_server')
      }
    }
  }, _vm._l((_vm.account.settings.stream_server.list), function(server, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": server.ip
      }
    }, [_vm._v(_vm._s(server.descr))])
  }), 0)]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Таймшифт")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.account.settings.timeshift.value
    },
    on: {
      "change": function($event) {
        return _vm.sendSettings($event, 'timeshift')
      }
    }
  }, _vm._l((_vm.account.settings.timeshift.list), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0)]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Кеширование")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.account.settings.http_caching.value
    },
    on: {
      "change": function($event) {
        return _vm.sendSettings($event, 'http_caching')
      }
    }
  }, _vm._l((_vm.account.settings.http_caching.list), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "link-wrapper"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.changeProtectedCodeMode = !_vm.changeProtectedCodeMode
      }
    }
  }, [_vm._v("Сменить родительский пароль")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeProtectedCodeMode),
      expression: "changeProtectedCodeMode"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldProtectedCode),
      expression: "oldProtectedCode"
    }],
    attrs: {
      "placeholder": "Старый родительский пароль"
    },
    domProps: {
      "value": (_vm.oldProtectedCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldProtectedCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProtectedCode),
      expression: "newProtectedCode"
    }],
    attrs: {
      "placeholder": "Новый родительский пароль"
    },
    domProps: {
      "value": (_vm.newProtectedCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newProtectedCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmProtectedCode),
      expression: "confirmProtectedCode"
    }],
    attrs: {
      "placeholder": "Повторите новый пароль"
    },
    domProps: {
      "value": (_vm.confirmProtectedCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmProtectedCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "disabled": !(_vm.oldProtectedCode && _vm.newProtectedCode && _vm.confirmProtectedCode)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeProtectedCode($event)
      }
    }
  }, [_vm._v("Подтвердить")])])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "checkbox-wrapper"
  }, [_c('span', [_vm._v("Показывать телетеку "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$parent.teletekaEnabled),
      expression: "$parent.teletekaEnabled"
    }],
    attrs: {
      "src": "dist/icon-check.svg"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.teletekaEnabled),
      expression: "$parent.teletekaEnabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.teletekaEnabled) ? _vm._i(_vm.$parent.teletekaEnabled, null) > -1 : (_vm.$parent.teletekaEnabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$parent.teletekaEnabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$parent, "teletekaEnabled", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$parent, "teletekaEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$parent, "teletekaEnabled", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "checkbox-wrapper"
  }, [_c('span', [_vm._v("Показывать статистику "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.debugSettings.statsEnabled),
      expression: "debugSettings.statsEnabled"
    }],
    attrs: {
      "src": "dist/icon-check.svg"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statsEnabled),
      expression: "statsEnabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.statsEnabled) ? _vm._i(_vm.statsEnabled, null) > -1 : (_vm.statsEnabled)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.statsEnabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statsEnabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statsEnabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statsEnabled = $$c
        }
      }, function($event) {
        return _vm.toggleStats(_vm.statsEnabled)
      }]
    }
  })])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "checkbox-wrapper"
  }, [_c('span', [_vm._v("Показывать метрику "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.debugSettings.metricsEnabled),
      expression: "debugSettings.metricsEnabled"
    }],
    attrs: {
      "src": "dist/icon-check.svg"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metricsEnabled),
      expression: "metricsEnabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.metricsEnabled) ? _vm._i(_vm.metricsEnabled, null) > -1 : (_vm.metricsEnabled)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.metricsEnabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.metricsEnabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.metricsEnabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.metricsEnabled = $$c
        }
      }, function($event) {
        return _vm.toggleMetrics(_vm.metricsEnabled)
      }]
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "title": "Выход",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Выйти")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-501a030e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 93
// module chunks = 0